import React, { useState, useEffect, useRef } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import Button from 'Components/Button/Button';


const Products = ({
    onUpdateProductIdSelected,
    productIdSelected,
    productFilters
}) => {
    const [idProduct, setIdProduct] = useState(null);
    const [supplierId, setSupplierId] = useState(null);
    const [dsProduct, setDsProduct] = useState(null);
    const [dsCloth, setDsCloth] = useState(null);
    const [size, setSize] = useState(null);
    const [serial, setSerial] = useState(null);
    const [collection, setCollection] = useState(null);
    const [productCode, setProductCode] = useState(null);
    const [username, setUsername] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(null);
    const [isActive, setIsActive] = useState('S');

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);

    const [loadingProductPanel, setLoadingProductPanel] = useState(null);
    const [recordsProductByUserId, setRcordsProductByUserId] = useState(null);
    const [attributesDetailProductPanel, setAttributesDetailProductPanel] = useState(null);
    const [supplierList, setSupplierList] = useState(null);

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loadingGrid, setLoadingGrid] = useState(false);
    const isFirstRender = useRef(true);

    const readOnlyAttributes = !(inserting || updating);

    const itemsSupplierOptions = OptionsDataByAttributePath(supplierList, ['description'], null, true);

    const attributeList = [
        { name: "id", value: idProduct, setter: setIdProduct },
        { name: "supplierId", value: supplierId, setter: setSupplierId, comboboxOptions: itemsSupplierOptions, width: '250px' },
        { name: "dsProduct", value: dsProduct, setter: setDsProduct, width: '500px', newRow: true },
        { name: "dsCloth", value: dsCloth, setter: setDsCloth, width: '350px' },
        { name: "size", value: size, setter: setSize },
        { name: "serial", value: serial, setter: setSerial },
        { name: "collection", value: collection, setter: setCollection, width: '250px' },
        { name: "productCode", value: productCode, setter: setProductCode },
        {
            name: "isActive",
            value: isActive,
            setter: setIsActive,
            resetValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ],
            newRow: true
        },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    // Filtros novos sempre começam da primeira página
    useEffect(() => {
        if (!productFilters) {
            return;
        }
        if (page !== 0) {
            setPage(0);
        } else {
            getProductRecords(0, pageSize);
        }
    }, [productFilters]);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
        } else {
            // Ao sair da inclusão/edição recarrega a página atual
            reloadListProduct()
        }
        if ((!productIdSelected || productIdSelected.length != 1) && updating) {
            setUpdating(false)
        }

        if (!productIdSelected || productIdSelected.length > 1) {
            onUpdateProductIdSelected([])
        }
    }, [inserting, updating]);


    useEffect(() => {
        if (productIdSelected && productIdSelected.length === 1) {
            fetchDataDetail(productIdSelected[0]);
        } else {
            fetchDataDetail(null);
        }
    }, [productIdSelected]);

    useEffect(() => {
        const onReady = async () => {
            await callToSetSupplierList();
        };

        onReady();
    }, []) // lista fixa: carrega uma vez ao abrir a tela

    async function callToSetSupplierList() {
        const supplierList = await ExecuteAxios.api('get', `/supplier/get-active-supplier-list/`);
        setSupplierList(supplierList);
    }

    const productPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '80%',
        width: '100%'
    };

    async function getProductRecords(pageToLoad = page, sizeToLoad = pageSize) {
        if (!productFilters) {
            return;
        }
        try {
            setLoadingGrid(true);
            const response = await ExecuteAxios.apiPaged(`/product/get-product-grid/`, productFilters, pageToLoad, sizeToLoad);
            if (!response) {
                return;
            }
            setRcordsProductByUserId(response.data);
            setTotalRecords(response.total);
            RemoveIdsNotFound.remove(response.data, onUpdateProductIdSelected, productIdSelected)
        } finally {
            setLoadingGrid(false);
        }
    }

    function onChangePage(newPage, newSize) {
        setPageSize(newSize);
        if (newPage === page) {
            getProductRecords(newPage, newSize);
        } else {
            setPage(newPage);
        }
    }

    useEffect(() => {
        getProductRecords(page, pageSize);
    }, [page]);

    const fetchDataDetail = async (productIdSelected) => {
        const parameters = { id: productIdSelected ? productIdSelected : 0 }
        const product = await ExecuteAxios.api('get', `/product/get-product-detail/`, { params: parameters })
        if (product) {
            setAttributesDetailProductPanel(product)
            ApplyAttributes.applyAttributes(product, attributeList)
        }

        if (!productIdSelected || productIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    function reloadListProduct() {
        getProductRecords(page, pageSize)
    }

    const getProductPanelListOrDetail = () => {
        if (!inserting && !updating) {
            return (
                <LoadingIndicator loaded={recordsProductByUserId && !loadingGrid}>
                    <PanelListDefault
                        onUpdateIdSelected={onUpdateProductIdSelected}
                        idsSelected={productIdSelected}
                        data={recordsProductByUserId}
                        attributeList={attributeList}
                        pagination={{
                            page: page,
                            size: pageSize,
                            total: totalRecords,
                            onChange: onChangePage,
                            disabled: loadingGrid
                        }}
                    />
                </LoadingIndicator>
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailProductPanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postProduct() {
        try {
            setLoadingProductPanel(true)
            const response = await ExecuteAxios.api('post', `/product/`, {
                supplierId: supplierId,
                dsProduct: dsProduct,
                productCode: productCode,
                dsCloth: dsCloth,
                serial: serial,
                size: size,
                collection: collection,
                isActive: isActive
            });

            if (response) {
                reloadListProduct()
            }

            return response;
        } finally {
            setLoadingProductPanel(false)
        }
    }

    async function putProduct() {
        try {
            setLoadingProductPanel(true)
            const response = await ExecuteAxios.api('put', `/product/`, {
                id: idProduct,
                supplierId: supplierId,
                dsProduct: dsProduct,
                productCode: productCode,
                dsCloth: dsCloth,
                serial: serial,
                size: size,
                collection: collection,
                isActive: isActive
            });

            if (response) {
                reloadListProduct()
            }

            return response;
        } finally {
            setLoadingProductPanel(false)
        }
    }

    function getDuplicateButton() {
        return (
            <Button
                clickMethod={() => { duplicateProduct() }}
                buttonName={'Duplicar produto'}
                style={styleDuplicateButton}
                disabled={productIdSelected && productIdSelected.length != 1}
                readOnly={productIdSelected && productIdSelected.length != 1}
            />
        )
    }

    const styleDuplicateButton = {
        width: '145px',
        float: 'right',
        color: productIdSelected && productIdSelected.length != 1 ? 'rgba(32, 27, 35, 0.53)' : 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '30px'
    };

    async function duplicateProduct() {
        try {
            setLoadingProductPanel(true)
            const response = await ExecuteAxios.api('post', `/product/duplicate/`, {
                id: productIdSelected[0]
            });

            if (response) {
                reloadListProduct()
            }

            return response;
        } finally {
            setLoadingProductPanel(false)
        }
    }

    return (
        <LoadingIndicator loaded={!loadingProductPanel}>
            <Panel
                style={productPanelStyle}
                titlePage={'Produtos'}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canEdit={productIdSelected && productIdSelected.length === 1}
                putFunction={putProduct}
                enableNewRecord={true}
                canNewRecord={true}
                postFunction={postProduct}
                canViewCRUD={true}
                readOnly={false}
                recordsSelected={productIdSelected}
                viewOnlyOneRecordCRUD={true}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributesDetailProductPanel}
                attributeList={attributeList}
                onUpdateIdSelected={onUpdateProductIdSelected}
                componentLeftButtons={getDuplicateButton()}
            >
                {getProductPanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );

}

export default Products;